export const getUserLevel = () => {
  let levelId = JSON.parse(localStorage.getItem("gradeId"));
  levelId =
    levelId === "2"
      ? "L1"
      : levelId === "5"
      ? "L2"
      : levelId === "8"
      ? "L3"
      : levelId === "12"
      ? "L4"
      : "L1";

  return levelId;
};
